import ApiClient from '../utils/apiClient';
import { configConstants } from '../utils/types';

export function getConfig() {
  const request = () => ({
    type: configConstants.GET_CONFIG_REQUEST
  });
  const success = data => ({
    type: configConstants.GET_CONFIG_SUCCESS,
    payload: {
      data
    }
  });
  const failure = error => ({
    type: configConstants.GET_CONFIG_FAILURE,
    payload: {
      error
    }
  });

  return dispatch => {
    dispatch(request());
    return ApiClient.get('/api/v1/config/')
      .then(response => {
        dispatch(success(response.data));
      })
      .catch(error => {
        dispatch(failure(error.response.data));
      });
  };
}

export function setAppInitialized(value) {
  return dispatch => {
    dispatch({
      type: configConstants.APP_INITIALIZED,
      payload: {
        appInitialized: value
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/actions/configActions.js